import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Safe localStorage wrapper for browsers with strict privacy settings (e.g., Edge)
const isLocalStorageAvailable = () => {
  try {
    const testKey = '__storage_test__';
    window.localStorage.setItem(testKey, testKey);
    window.localStorage.removeItem(testKey);
    return true;
  } catch (e) {
    return false;
  }
};

const memoryStorage = {};

export const safeStorage = {
  getItem: (key) => {
    if (isLocalStorageAvailable()) {
      return localStorage.getItem(key);
    }
    return memoryStorage[key] || null;
  },
  setItem: (key, value) => {
    if (isLocalStorageAvailable()) {
      localStorage.setItem(key, value);
    } else {
      memoryStorage[key] = value;
    }
  },
  removeItem: (key) => {
    if (isLocalStorageAvailable()) {
      localStorage.removeItem(key);
    } else {
      delete memoryStorage[key];
    }
  }
};

export function formatPrice(price) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(price);
}

export function formatDimensions(width, height) {
  return `${width}" W × ${height}" H`;
}

// Address stored as a string or as {street, city, state, zip}; '' when empty
export function formatAddress(a) {
  if (!a) return '';
  if (typeof a === 'string') return a;
  return [a.street, a.city, a.state, a.zip].filter(Boolean).join(', ');
}


export function generateSessionId() {
  return 'session_' + Math.random().toString(36).substring(2, 15);
}

export function getSessionId() {
  let sessionId = safeStorage.getItem('shade_session_id');
  if (!sessionId) {
    sessionId = generateSessionId();
    safeStorage.setItem('shade_session_id', sessionId);
  }
  return sessionId;
}
